import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import {
  Grid,
  Typography
} from '@material-ui/core';
import RatingStar from 'public/images/icons/rating-star';

const RatingAverage = ({ classes, totalAverage, totalReviews, modal }) => (
    <Grid container item xs={12} direction={(modal) ? "column" : "row"} alignItems="center">
      <Grid item xs={1} className={classes.starWrapper}>
        <RatingStar width={18} height={17}/>
      </Grid>

      <Grid item xs={11} style={{ paddingLeft: '7px'}}>
        <Typography xs={5}
          variant='body1'
          color="textPrimary"
          className={classes.text}
        >
          {totalAverage}
          {(totalReviews) ? ` · ${totalReviews} Avaliações` : ''}
        </Typography>
      </Grid>
    </Grid>
  );

RatingAverage.defaultProps = {
  modal: false,
  totalReviews: '',
};

RatingAverage.propTypes = {
  classes: PropTypes.object.isRequired,
  totalAverage: PropTypes.any.isRequired,
  totalReviews: PropTypes.any,
  modal: PropTypes.bool,
};

const styles = () => ({
  starWrapper: { maxWidth: '20px'},
  text: { fontWeight: 700 }
});

export default withStyles(styles)(RatingAverage);
